import React, { useState, useEffect } from 'react';
import { getAgentDisplay } from '../chat/ChatMessage';
import { Loader2 } from 'lucide-react';
import { WORKING_MESSAGES } from './TypingIndicator';

const CODE_MESSAGES = [
  "Writing code...",
  "Building your component...",
  "Crafting the logic...",
  "Assembling the files...",
  "Generating clean code...",
  "Wiring things up...",
  "Adding the finishing touches...",
  "Making it production-ready...",
  "Structuring the architecture...",
  "Optimizing the output...",
];

const StreamingMessage = ({ streamingContent, streamingAgent }) => {
  const [codeMsgIndex, setCodeMsgIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCodeMsgIndex(prev => (prev + 1) % CODE_MESSAGES.length);
    }, 2200);
    return () => clearInterval(interval);
  }, []);

  if (!streamingContent) return null;

  const agentInfo = streamingAgent ? getAgentDisplay(streamingAgent) : { name: 'E1', icon: 'E1', color: 'bg-gradient-to-br from-blue-600 to-cyan-500 text-white' };

  // Strip code blocks from streaming — only show text
  const textOnly = streamingContent.replace(/```[\s\S]*?(?:```|$)/g, '').trim();
  const hasCode = streamingContent.includes('```');

  return (
    <div className="flex gap-3" data-testid="streaming-message">
      <div className={`w-7 h-7 rounded-lg ${agentInfo.color} flex items-center justify-center text-[10px] font-bold shrink-0 mt-0.5`}>{agentInfo.icon}</div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-1">
          <span className="text-sm font-semibold text-foreground">{agentInfo.name}</span>
          <span className="text-xs text-primary animate-pulse">writing...</span>
        </div>
        {textOnly && (
          <div className="text-sm leading-[1.75] text-foreground/80 whitespace-pre-wrap">
            {textOnly}
          </div>
        )}
        {hasCode && (
          <div className="flex items-center gap-2.5 mt-2 px-4 py-3 bg-slate-900 rounded-xl">
            <Loader2 className="w-4 h-4 text-blue-400 animate-spin shrink-0" />
            <span className="text-sm text-muted-foreground transition-all duration-300" key={codeMsgIndex}>
              {CODE_MESSAGES[codeMsgIndex]}
            </span>
          </div>
        )}
        {!textOnly && !hasCode && (
          <span className="inline-block w-1.5 h-4 bg-primary ml-0.5 animate-pulse rounded-sm" />
        )}
      </div>
    </div>
  );
};

export default StreamingMessage;
